import { render } from "./AddDocument.vue?vue&type=template&id=3765adeb&scoped=true"
import script from "./AddDocument.vue?vue&type=script&lang=js"
export * from "./AddDocument.vue?vue&type=script&lang=js"

import "./AddDocument.vue?vue&type=style&index=0&id=3765adeb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3765adeb"]])

export default __exports__